import App from '@/App.vue';
import '@/assets/css/app.scss';
import { i18n } from '@/plugins/i18n';
import { Trans } from '@/plugins/Translation';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import func from '@/utils/globalFunctions.js';
import axios from 'axios';
import Vue from 'vue';
import Affix from 'vue-affix';
import VueAnalytics from 'vue-analytics';
import VueAxios from 'vue-axios';
import VueCarousel from 'vue-carousel';
import VueClipboard from 'vue-clipboard2';
import VueCookies from 'vue-cookies';
import fullscreen from 'vue-fullscreen';
import VueLazyload from 'vue-lazyload';
import Meta from 'vue-meta';
import VueSocialSharing from 'vue-social-sharing';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Vuex from 'vuex';
import { sync } from 'vuex-router-sync';

Vue.use(Vuex);
Vue.use(fullscreen);
Vue.use(VueCarousel);
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(Meta);
Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.use(VueSocialSharing);
Vue.use(Affix);
Vue.use(VueCookies);

if (process.env.ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.ANALYTICS_ID
  });
}

Vue.prototype.$func = func;

Vue.filter('removeAccents', function (str) {
  let accents =
    'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  let accentsOut =
    'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
  str = str.split('');
  str.forEach((letter, index) => {
    let i = accents.indexOf(letter);
    if (i != -1) {
      str[index] = accentsOut[i];
    }
  });
  return str.join('').replace(/ /g, '-');
});

Vue.config.productionTip = false;

sync(store, router);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response.status === 401) {
      store.commit('logout');
      router.push({ name: 'welcome' });
    }

    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  config => {
    // eslint-disable-next-line no-undef
    config.baseURL = __API__;
    config.headers.common['api-version'] = '3';
    config.headers.common['Content-Type'] = 'application/json';
    config.headers.common['Accept-Language'] = Trans.currentLanguage;

    if (Vue.cookies.get('sctoken')) {
      config.headers.common['Authorization'] = `Bearer ${Vue.cookies.get(
        'sctoken'
      )}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
